import {configureStore} from "@reduxjs/toolkit";
import {createCustomer, customerSlice, setCustomerState} from "./slices/customerSlice";
import {Customer} from "../typescript-library";
import {AsyncThunkFulfilledActionCreator} from "@reduxjs/toolkit/src/createAsyncThunk";
import {createWishlist, updateWishlistState, wishlistSlice} from "./slices/wishlishSlice";
import {UrlSearchParamsHelper} from "../helpers/urlSearchParamsHelper";

export const store = configureStore({
  reducer: {
    [customerSlice.name]: customerSlice.reducer,
    [wishlistSlice.name]: wishlistSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

// get customer and emmit event handling
void store.dispatch(createCustomer()).then((data: ReturnType<AsyncThunkFulfilledActionCreator<Customer, void>>) => {
  const customer = data.payload;
  customer.emitter.on(() => {
    store.dispatch(setCustomerState(customer));
  });

  const urlParamItemId = UrlSearchParamsHelper.wishlistItemId;
  if (customer.isRecognised) {
    void store
      .dispatch(createWishlist({visitorId: customer.visitorId, itemId: urlParamItemId ?? undefined}))
      .then(() => {
        if (urlParamItemId) {
          store.dispatch(updateWishlistState({itemIdToShowOnPopup: urlParamItemId}));
        }
      });
  } else if (urlParamItemId) {
    store.dispatch(updateWishlistState({itemIdToBeAdded: urlParamItemId}));
  }
});
